import React from "react";
import { Container, Row, Col } from "reactstrap";

import imgNotFound from "../../assets/images/not-found.png";
import { ACCESS_TOKEN, removeLocalStorage } from "src/utils/storage";
import { useSetRecoilState } from "recoil";
import { authState } from "src/recoil/atoms/auth";
import { REACT_APP_PORTAL_URL } from "src/constant/environment";

const AccessDenied = () => {
  const setAuth = useSetRecoilState(authState);

  const handleToLogin = () => {
    removeLocalStorage(ACCESS_TOKEN);
    setAuth({});
    window.location.href = REACT_APP_PORTAL_URL;
  };

  return (
    <React.Fragment>
      <div className="account-pages my-5">
        <Container>
          <Row className="justify-content-center">
            <Col xl={4} lg={5}>
              <div className="text-center">
                <div>
                  <img src={imgNotFound} alt="" className="img-fluid" />
                </div>
              </div>
            </Col>
          </Row>

          <Row>
            <Col className="text-center">
              <h3 className="mt-3">Access Denied.</h3>
              <button
                onClick={handleToLogin}
                className="btn btn-lg btn-primary mt-4"
              >
                Take Me back to Portal
              </button>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default AccessDenied;
